import React, { Component } from "react";
import Typed from "react-typed";
class HeroSection extends Component {
  render() {
    return (
      <section
        id="hero"
        className="d-flex flex-column justify-content-center align-items-center"
      >
        <div className="hero-container" data-aos="fade-in">
          <h1>Akshay Nahar</h1>
          <p>
            I'm&nbsp;
            <span> 
              <Typed
                strings={[
                  "Designer",
                  "Developer",
                  "Freelancer",
                  // "Photographer",
                ]}
                typeSpeed={40}
                backSpeed={50}
                loop
              />
            </span>
            {/* <span
              className="typed"
              data-typed-items="Designer, Developer, Freelancer, Photographer"
            ></span> */}
          </p>
        </div>
      </section>
    );
  }
}

export default HeroSection;
